import { FormControlLabel } from "@material-ui/core";
import StyledSwitch from "./styles/Switch";

const SwitchERP = ({ label, labelPlacement, value, onChange, disabled }) => {
  return (
    <FormControlLabel
      label={label}
      style={{ margin: !label && 0 }}
      labelPlacement={labelPlacement}
      control={
        <StyledSwitch checked={value} onChange={onChange} disabled={disabled} />
      }
      checked
    />
  );
};

export default SwitchERP;
